import { Check } from 'lucide-react';
import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

/**
 * Minimal styled checkbox. Native input for accessibility; the <span> is a
 * visual indicator shown only when the input is :checked.
 */
export const Checkbox = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <span className={cn('relative inline-flex h-4 w-4 items-center justify-center', className)}>
      <input
        ref={ref}
        type="checkbox"
        className="peer h-4 w-4 cursor-pointer appearance-none rounded-sm border border-input bg-background shadow-sm checked:border-primary checked:bg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
        {...props}
      />
      <Check className="pointer-events-none absolute hidden h-3 w-3 text-primary-foreground peer-checked:block" />
    </span>
  ),
);
Checkbox.displayName = 'Checkbox';
